@if(loadingService.loading()) {
  <div class="global-overlay">
    <div class="splash-loader-container">
      <div class="splash-loader">
        <div class="splash-cube1"></div>
        <div class="splash-cube2"></div>
        <div class="splash-cube4"></div>
        <div class="splash-cube3"></div>
      </div>
      @if(message()) {
        <div class="loading-message">{{ message() }}</div>
      }
    </div>
  </div>
}
